import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Inheritance_hierarchy extends PureComponent {
  render() {
    return (
      <div className="row" id="inheritance_hierarchy">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Inheritance Hierarchy</h2>
              <p>
                Before we go into how to create your custom interface or module,
                we need to understand how the hierarchy works. When you first
                create your Nexoid account, you're asked if you wish to
                subscribe to any pre-built modules. These modules are complete
                applications and give you a huge amount a functionality with
                very little if any customization required.
              </p>
              <p>
                If you choose the wrong modules or would like to experiment with
                others, you can change this after setting up your account in the
                settings section under modules, subscriptions.
              </p>
              <p>
                These subscriptions or pre-built models are at the top layer of
                the hierarchy. The next layer is the customization which you can
                access through settings modules customization. Hear an
                administrator can add some JSON code, which will add to or
                override anything in the subscribed modules.
              </p>

              <p>
                This method allows you to create new data objects, add fields,
                change names, add translations etc. Anything you need to do in
                the interface can be manipulated through a JSON customization
                here. There are three places where an administrator can
                customize the interface or module.
              </p>
              <p>
                The first is the module customization tool, which allows you to
                edit the interface module or model at a company level. The
                second is at a group level, and the third is at a user level.
                You can edit the interface at the company level with the
                customization tool, which can be found under settings, modules,
                customization.
              </p>
              <p>
                Group level customization can be done in the "groups" section of
                the administration settings. To access group model
                customization, you need to select the override option, which
                will allow you to edit the interface model and default record
                level permissions. Because users can be in more than one group,
                group model customizations need to be applied in the correct
                order. This is why there is an order drop-down when customizing
                a group. This makes it possible for a user to be a member of a
                group that changes part of the interface and also be a member of
                a second group that reverts a change.
              </p>
              <p>
                The Last type of customization is user-level. This is the fourth
                level in the hierarchy. User customization cannot be exported.
                Although we offer user-level customization, we feel it is best
                practice to keep customizations and permissions at the company
                or group level.
              </p>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Order</td>
                    <td className="b top">Model</td>
                  </tr>
                  <tr>
                    <td className="b">1</td>
                    <td>Subscriptions</td>
                  </tr>
                  <tr>
                    <td className="b">2</td>
                    <td>Customisation</td>
                  </tr>
                  <tr>
                    <td className="b">3</td>
                    <td>Group Customisation (may contain multiple models)</td>
                  </tr>
                  <tr>
                    <td className="b">4</td>
                    <td>User Customisation</td>
                  </tr>
                </tbody>
              </table>
              <p>
                Now that we have an understanding of the four levels of the
                hierarchy, we need to understand how to add and subtract through
                a previous level. You can think of each level as simply
                overlaying the new model on top of the old one overwriting any
                existing fields and adding any missing fields. To remove a
                field, all you need to do is override a property with a null
                value.
              </p>
              <p>
                In example 1, you can see what happens when JSON in the first
                level is overridden by JSON in the second level. In this
                example, you can see "menu_hide" being removed, "menu_order"
                being added, and "menu_name" being changed from "My Incident to
                "Incidents".
              </p>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Inheritance Hierarchy Example</h2>
            </section>
            <section>
              <h3>Example: Adding, Editing and Removing</h3>
              <div className="darkCode">
                <div>Level 1:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"menu_name"</span>:{" "}
                  <span className="jsonY">"My Incidents"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_description"</span>:{" "}
                  <span className="jsonY">"My Description"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_hide"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
                <div>
                  <br />
                </div>
                <div>Level 2:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"menu_name"</span>:{" "}
                  <span className="jsonY">"Incidents"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_order"</span>:{" "}
                  <span className="jsonP">"10"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_hide"</span>:{" "}
                  <span className="jsonP">null</span>
                </div>
                <div>&#125;</div>
                <div>
                  <br />
                </div>
                <div>Output:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"menu_name"</span>:{" "}
                  <span className="jsonY">"Incidents"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_description"</span>:{" "}
                  <span className="jsonY">"My Description"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"menu_order"</span>:{" "}
                  <span className="jsonP">"10"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Inheritance_hierarchy;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Inheritance_hierarchy.js